import { signal, effect, onDispose, peek } from 'maverick.js';
import { isDOMElement, setAttribute } from 'maverick.js/std';

// src/foundation/observers/class-manager.ts
var ClassManager = class {
  constructor(el) {
    this.K = -1;
    this.wb = /* @__PURE__ */ new Map();
    this.Dc = signal([]);
    this.Bc = el.firstChild;
    this.Cc = new MutationObserver(this.rb.bind(this));
    this.Cc.observe(this.Bc, { subtree: true, childList: true });
    effect(this.Gg.bind(this));
    onDispose(this.Rb.bind(this));
  }
  rb(records) {
    const selector = Array.from(this.wb.keys()).join(",");
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (isDOMElement(node) && node.matches(selector))
          this.J();
      }
    }
  }
  t(selector, $class) {
    this.wb.set(selector, $class);
    this.Dc.set((c) => [...c, $class]);
    return this;
  }
  J() {
    window.cancelAnimationFrame(this.K);
    this.K = requestAnimationFrame(() => {
      for (const [selector, classes] of this.wb) {
        const _class = peek(classes);
        for (const el of this.Bc.querySelectorAll(selector)) {
          setAttribute(el, "class", _class);
        }
      }
      this.K = -1;
    });
  }
  Gg() {
    for (const c of this.Dc())
      c();
    this.J();
  }
  Rb() {
    this.Dc.set([]);
    this.wb.clear();
    this.Cc.disconnect();
  }
};

export { ClassManager };
